/**
 * @generated SignedSource<<1be148f635a2c3f6fa0d2dc1957342ed>>
 * @relayHash 342423ec891413be30112dca6609beaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e9c852c98f9d1d09ab6a01a1092fb150dcadfc4dbfcd542c6f9513abedfb01b7

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceInlineTaskStatus = "COMPLETE" | "INCOMPLETE" | "%future added value";
export type InlineTasksQuerySortColumn = "ASSIGNEE" | "DUE_DATE" | "PAGE_TITLE" | "%future added value";
export type InlineTasksQuerySortOrder = "ASCENDING" | "DESCENDING" | "%future added value";
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type InlineTasksByMetadata = {
  accountIds?: InlineTasksQueryAccountIds | null;
  after?: string | null;
  completedDateRange?: InlineTasksQueryDateRange | null;
  createdDateRange?: InlineTasksQueryDateRange | null;
  dueDate?: InlineTasksQueryDateRange | null;
  first: number;
  forCurrentPageOnly?: boolean | null;
  isNoDueDate?: boolean | null;
  pageIds?: ReadonlyArray<AGG$Long | null> | null;
  sortParameters?: InlineTasksQuerySortParameters | null;
  spaceIds?: ReadonlyArray<AGG$Long | null> | null;
  spaceKeys?: ReadonlyArray<string | null> | null;
  status?: TaskStatus | null;
};
export type InlineTasksQueryAccountIds = {
  assigneeAccountIds?: ReadonlyArray<string | null> | null;
  completedByAccountIds?: ReadonlyArray<string | null> | null;
  creatorAccountIds?: ReadonlyArray<string | null> | null;
};
export type InlineTasksQueryDateRange = {
  endDate?: AGG$Long | null;
  startDate?: AGG$Long | null;
};
export type InlineTasksQuerySortParameters = {
  sortColumn: InlineTasksQuerySortColumn;
  sortOrder: InlineTasksQuerySortOrder;
};
export type GetTasksReportQuery$variables = {
  cloudId?: string | null;
  taskQuery: InlineTasksByMetadata;
};
export type GetTasksReportQuery$data = {
  readonly inlineTasks: {
    readonly endCursor: string | null;
    readonly inlineTasks: ReadonlyArray<{
      readonly assignedTo: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly body: {
        readonly adf: string | null;
      } | null;
      readonly container: {
        readonly __typename: "ConfluenceBlogPost";
        readonly blogPostId: string;
        readonly id: string;
        readonly labels: ReadonlyArray<{
          readonly label: string | null;
          readonly prefix: string | null;
        } | null> | null;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly name: string | null;
          readonly spaceId: string;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly labels: ReadonlyArray<{
          readonly label: string | null;
          readonly prefix: string | null;
        } | null> | null;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly pageId: string;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly name: string | null;
          readonly spaceId: string;
        } | null;
        readonly title: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly createdAt: string | null;
      readonly createdBy: {
        readonly accountId: string;
        readonly displayName: string | null;
      } | null;
      readonly dueAt: string | null;
      readonly id: string;
      readonly status: ConfluenceInlineTaskStatus | null;
      readonly taskId: string | null;
    } | null> | null;
  } | null;
};
export type GetTasksReportQuery = {
  response: GetTasksReportQuery$data;
  variables: GetTasksReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskQuery"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "tasksQuery",
    "variableName": "taskQuery"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "taskId"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = {
  "kind": "ScalarField",
  "name": "dueAt"
},
v7 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "profilePicture",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    }
  ]
},
v11 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v12 = {
  "concreteType": "ConfluenceContentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "adf"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "ScalarField",
  "name": "pageId"
},
v15 = {
  "kind": "ScalarField",
  "name": "title"
},
v16 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v17 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v16/*: any*/)
},
v18 = {
  "kind": "ScalarField",
  "name": "label"
},
v19 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v20 = {
  "concreteType": "ConfluenceLabel",
  "kind": "LinkedField",
  "name": "labels",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/)
  ]
},
v21 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "spaceId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v16/*: any*/)
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "blogPostId"
},
v23 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v16/*: any*/)
},
v24 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v25 = {
  "concreteType": "ConfluenceLabel",
  "kind": "LinkedField",
  "name": "labels",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/),
    (v3/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GetTasksReportQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "ConfluencePage"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v22/*: any*/),
                      (v15/*: any*/),
                      (v23/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "ConfluenceBlogPost"
                  }
                ]
              }
            ]
          },
          (v24/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetTasksReportQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v25/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "ConfluencePage"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v22/*: any*/),
                      (v15/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "ConfluenceBlogPost"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          (v24/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "342423ec891413be30112dca6609beaf",
    "id": "e9c852c98f9d1d09ab6a01a1092fb150dcadfc4dbfcd542c6f9513abedfb01b7",
    "metadata": {},
    "name": "GetTasksReportQuery",
    "operationKind": "query",
    "text": "query GetTasksReportQuery($taskQuery:InlineTasksByMetadata!,$cloudId:ID){inlineTasks(tasksQuery:$taskQuery,cloudId:$cloudId){inlineTasks{id,taskId,status,dueAt,createdAt,assignedTo{accountId,displayName,profilePicture{path}},createdBy{accountId,displayName},body{adf},container{__typename,...on ConfluencePage{id,pageId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
  }
};
})();

(node as any).hash = "72e6fef5c1e8b779938b3c0c3f18e732";

export default node;
